import {
  IGetNotificationResponse,
  IGetTopicResponse,
  IPatchNotificationRequest,
  IPostNotificationRequest,
} from "../../interface/notification";
import request, { BaseResponse } from "../core";

export const getNotification = async () => {
  return await request.get<BaseResponse<IGetNotificationResponse[]>>(
    `/app/push/subscriber`
  );
};

export const getTopic = async () => {
  return await request.get<BaseResponse<IGetTopicResponse[]>>(
    `/app/push/topic`
  );
};

// patch는 등록된 구독 정보를 수정하는 요청이고, post는 웹 단에서 최초 회원가입 시 알림 기기 구독을 등록하는 요청입니다.

export const patchNotification = async (data: IPatchNotificationRequest) => {
  return await request.patch<BaseResponse<boolean>>(
    `/app/push/subscriber/topic`,
    data
  );
};

export const postNotification = async (data: IPostNotificationRequest) => {
  return await request.post<BaseResponse<boolean>>(
    `/app/push/subscriber/topic`,
    data
  );
};
